import React from 'react';
import { Advantages as AdvantagesComponent } from '../../components';
import { AppSection, AppTitle } from '../Conditions/Conditions';
import { Container } from 'react-bootstrap';

const Advantages = () => {
  return (
    <AppSection className="advantages">
      <Container>
        <AppTitle>Наши преимущества</AppTitle>
        <AdvantagesComponent />
      </Container>
    </AppSection>
  );
};

export default Advantages;
